<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewUsers.title')}}</h3>
    <v-progress-circular
        indeterminate
        color="primary"
        v-if="!fetched"
    ></v-progress-circular>
    <v-sheet class="mt-2 elevation-0" elevation="0" v-if="fetched && user!=null">
        <v-flex xs12 lg6>
          <v-form>
            <span @click.stop="isVisibleProfilePhotoEditor=!isVisibleProfilePhotoEditor" class="d-block mb-5 pointer">
              <user-profile-photo :profile-photo="user.profile_photo" :size="120" :blob="user.profile_photo_blob"></user-profile-photo>
            </span>
            <user-profile-photo-editor
                :show="isVisibleProfilePhotoEditor"
                :user="user"
                @update="(data)=>{user.profile_photo=data;isVisibleProfilePhotoEditor=!isVisibleProfilePhotoEditor}"
                @hide="isVisibleProfilePhotoEditor=!isVisibleProfilePhotoEditor"
                @set-image="(blob)=>{user.profile_photo_blob = blob;isVisibleProfilePhotoEditor=!isVisibleProfilePhotoEditor; convertPhotoToDataUrl()}"
            />
            <v-text-field
                v-model="user.name"
                :error-messages="nameErrors"
                :label="$t('user.name')"
                append-icon="fa-user"
                required
                outlined
                @input="$v.user.name.$touch()"
                @blur="$v.user.name.$touch()"
                @keyup.enter="submit"
            ></v-text-field>
            <v-text-field
                v-model="user.email"
                :error-messages="emailErrors"
                :label="$t('user.email')"
                append-icon="fa-envelope"
                required
                outlined
                @input="$v.user.email.$touch()"
                @blur="$v.user.email.$touch()"
                @keyup.enter="submit"
            ></v-text-field>
            <v-text-field
                v-model="user.phone"
                :error-messages="phoneErrors"
                :label="$t('common.phone')"
                append-icon="fa-phone"
                required
                outlined
                @input="$v.user.phone.$touch()"
                @blur="$v.user.phone.$touch()"
                @keyup.enter="submit"
            ></v-text-field>
            <v-text-field
                v-model="user.extension_phone_number"
                :error-messages="extensionPhoneNumberErrors"
                :label="$t('user.extension_phone_number')"
                append-icon="fa-phone-square"
                required
                outlined
                @input="$v.user.extension_phone_number.$touch()"
                @blur="$v.user.extension_phone_number.$touch()"
                @keyup.enter="submit"
            ></v-text-field>
            <v-switch
                v-if="user.id>0"
                color="primary"
                v-model="changePassword"
                :label="$t('common.change_password')"
            ></v-switch>
            <v-text-field
                v-if="changePassword"
                v-model="user.password"
                :error-messages="passwordErrors"
                :label="$t('common.password')"
                :append-icon="(user.password===user.password_confirmation)?'fa-lock':'fa-lock-open'"
                required
                outlined
                type="password"
                @input="$v.user.password.$touch()"
                @blur="$v.user.password.$touch()"
                @keyup.enter="submit"
            ></v-text-field>
            <v-text-field
                v-if="changePassword"
                v-model="user.password_confirmation"
                :error-messages="passwordConfirmErrors"
                :label="$t('common.password_confirmation')"
                :append-icon="(user.password===user.password_confirmation)?'fa-lock':'fa-lock-open'"
                required
                outlined
                type="password"
                @input="$v.user.password_confirmation.$touch()"
                @blur="$v.user.password_confirmation.$touch()"
                @keyup.enter="submit"
            ></v-text-field>
            <v-divider class="mb-5"></v-divider>
            <!--Доступ пользователя к платформам-->
            <h3 class="pb-3" v-if="userShopsList.length">{{ $t('user.users_platforms') }}:
              <v-dialog v-model="userPlatformsDialog" scrollable max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn
                    color="primary"
                    x-small
                    fab
                    max-width="26"
                    max-height="26"
                    v-on="on"
                    elevation="0"
                >
                  <v-icon x-small>$pencil</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-actions>
                  <v-card-title><strong></strong></v-card-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="userPlatformsDialog = false">
                    <v-icon>fa-times</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-list>
                  <v-list-item v-for="(shop, i) in userShopsList">
                    <v-list-item-action>
                      <v-switch
                          v-model="user.shops"
                          @change="setUserShop(shop)"
                          :value="shop"
                      >
                      </v-switch>
                    </v-list-item-action>
                    <v-list-item-title>
                      {{ shop.legal_name }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-dialog></h3>
            <div v-if="user && user.shops &&  userShopsList.length">
              <v-chip
                  class="ma-2 text-no-wrap"

                  v-for="(shop, i) in user.shops"
                  small
              >
                {{ shop.legal_name }}
              </v-chip>
            </div>

            <!--Роли пользователя-->
            <h3 class="pb-3">{{ $t('user.users_roles') }}:
              <v-menu
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                      color="success"
                      class="green-shadow"
                      x-small
                      fab
                      max-width="26"
                      max-height="26"
                      v-on="on"
                  >
                    <v-icon x-small>$plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item v-for="(role, i) in roles">
                      <v-list-item-action>
                        <v-switch
                            v-model="userRoles[role.id+'_'+role.type]"
                            @change="setUserRoles"
                            :color="role.type==='system'?'orange':'green'"
                            :value="role"
                        >
                        </v-switch>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ role.type === 'system' ? $t('common.systemRolesNames.' + role.name) : role.name }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </h3>
            <div v-if="user && user.all_roles">
              <v-chip
                  class="ma-2 text-no-wrap"
                  :color="(item.type==='system')?'orange':'green'"
                  text-color="white"
                  v-for="(item, i) in user.all_roles[activeShopId]"
                  small
                  :title="(item.type==='system')?$t('viewUsers.hints.it_is_system_role'):''"
                  close
                  @click:close="user.all_roles[activeShopId].splice(user.all_roles[activeShopId].findIndex((o)=>o.id===item.id), 1)"
              >
                {{ (item.type === 'system') ? $t('common.systemRolesNames.' + item.name) : item.name }}
              </v-chip>
            </div>
            <v-divider class="my-5"></v-divider>

            <!--расширенные права пользователя-->
            <h3 class="pb-3">{{ $t('user.users_extra_rights') }}:
              <v-dialog v-model="userExtraRightsDialog" scrollable max-width="800px">
                <template v-slot:activator="{ on }">
                  <v-btn
                      color="primary"
                      x-small
                      fab
                      max-width="26"
                      max-height="26"
                      v-on="on"
                      elevation="0"
                  >
                    <v-icon x-small>$pencil</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-actions>
                    <v-card-title><strong></strong></v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="userExtraRightsDialog = false">
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-divider></v-divider>
                  <v-list>

                    <v-list-item v-for="(right, i) in rights">
                      <v-list-item-title v-if="user && user.extra_rights">
                        <v-select
                            @change="setUserExtraRights"
                            clearable
                            v-model="userExtraRights[right.name]"
                            :items="rightsValues"
                            :label="$t('rightsNames.'+right.name)"
                        >
                        </v-select>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-dialog>
            </h3>
            <div v-if="user">
              <template v-for="(right_value, right_name) in user.extra_rights[activeShopId]">
                <v-chip
                    class="ma-2 text-no-wrap"
                    :color="extraRightsColors(right_value)"
                    text-color="white"
                    small
                    v-if="right_value || right_value===0"
                >
                    <v-icon x-small>{{ extraRightsSymbol(right_value) }}</v-icon>
                    {{ $t('rightsNames.' + right_name) }}:
                    {{ $t('right.availableValues.' + right_value).toLowerCase() }}
                </v-chip>
              </template>
            </div>
            <v-divider class="mt-5"></v-divider>
            <v-spacer></v-spacer>
            <v-btn
                class="mt-5 white--text mr-4"
                color="red"
                elevation="0"
                :to="{ name: 'users'}"
            >
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
                elevation="0"
                class="mt-5"
                color="primary"
                @click="submit"
                @keyup.enter="submit"
                :loading="savingInProgress"
                :disabled="savingInProgress"
            >
              {{ $t('common.save') }}
            </v-btn>
          </v-form>
        </v-flex>
    </v-sheet>
  </div>
</template>
<script>
import {required, email, sameAs, minLength,integer,} from "vuelidate/lib/validators";
import {mapState} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import i18n from "@/i18n";
import axios from "axios";
import RightsMixin from "@/mixins/rights";
import UserProfilePhoto from "@/components/user/UserProfilePhoto";
import UserProfilePhotoEditor from "@/components/user/UserProfilePhotoEditor";

export default {
  components: {UserProfilePhotoEditor, UserProfilePhoto},
  mixins: [RightsMixin],
  data: () => ({
    isVisibleProfilePhotoEditor: false,
    userShops: [],
    userRoles: [],
    userExtraRights: {},
    userExtraRightsDialog: false,
    userPlatformsDialog: false,
    changePassword: false
  }),
  created() {
    this.onLoad();
  },
  validations() {
    let res = {
      user: {
        email: {required, email},
        phone: {integer},
        name: {required},
        extension_phone_number: {integer},
      }
    }
    if (this.changePassword) {
      res.user.password = {required, minLength: minLength(6)};
      res.user.password_confirmation = {sameAsPassword: sameAs('password')};
    }
    return res;
  },
  watch: {
    changePassword(newValue, oldValue) {
      if (newValue !== true) {
        delete this.user.password;
        delete this.user.password_confirmation;
      }
    },
    '$route'(to, from) {
      this.onLoad();
    },
  },
  computed: {
    ...mapState('rights', ['rights']),
    ...mapState('roles', ['roles']),
    ...mapFields('users', ['user', 'fetched', 'savingInProgress']),
    userShopsList(){
      const INT_VALUE_FOR_FULL_ACCESS = 2; //
      const PERMISSION_NAME_FOR_MANAGE_USERS = 'users';
      let idsOfShopsWhereCurrentAuthorizedUserHasPermissionForManageUsers = [];
      for (let shop_id in this.authenticatedUser.all_rights){
        for(let permission in  this.authenticatedUser.all_rights[shop_id]){
          //manage_users === 2
          if(this.authenticatedUser.all_rights[shop_id][permission] === INT_VALUE_FOR_FULL_ACCESS && permission === PERMISSION_NAME_FOR_MANAGE_USERS){
            idsOfShopsWhereCurrentAuthorizedUserHasPermissionForManageUsers.push(parseInt(shop_id));
          }
        }
      }
      let list = this.authenticatedUser.shops.filter((shop) => {
        return idsOfShopsWhereCurrentAuthorizedUserHasPermissionForManageUsers.includes(parseInt(shop.id)) || this.isOwnerOfShop(shop)
      });
      return list;
    },
    activeShopId(){
      return this.authenticatedUser.active_shop_id;
    },
    emailErrors() {
      const errors = []
      if (!this.$v.user.email.$dirty) return errors
      !this.$v.user.email.email && errors.push(this.$t('form.validationErrors.email_not_valid')) //this.$t('form.validationErrors.email_required')
      !this.$v.user.email.required && errors.push(this.$t('form.validationErrors.email_required'))
      return errors;
    },
    nameErrors() {
      const errors = []
      if (!this.$v.user.name.$dirty) return errors
      !this.$v.user.name.required && errors.push(this.$t('form.validationErrors.field_is_required'))
      return errors;
    },
    phoneErrors() {
      const errors = []
      if (!this.$v.user.phone.$dirty) return errors
      !this.$v.user.phone.integer && errors.push(this.$t('form.validationErrors.must_be_integer'))
      return errors;
    },
    extensionPhoneNumberErrors() {
      const errors = []
      if (!this.$v.user.extension_phone_number.$dirty) return errors
      !this.$v.user.extension_phone_number.integer && errors.push(this.$t('form.validationErrors.must_be_integer'))
      return errors;
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.user.password) return errors
      if (!this.$v.user.password.$dirty) return errors
      !this.$v.user.password.required && errors.push(this.$t('form.validationErrors.field_is_required'))
      !this.$v.user.password.minLength && errors.push(this.$t('form.validationErrors.minLength', [6]))
      return errors;
    },
    passwordConfirmErrors() {
      const errors = []
      if (!this.$v.user.password_confirmation) return errors;
      if (!this.$v.user.password_confirmation.$dirty) return errors;
      !this.$v.user.password_confirmation.sameAsPassword && errors.push(this.$t('form.validationErrors.password_confirmation_doesnt_match'))
      return errors;
    },
    rightsValues() {
      return [
        {text: '', value: null},
        {text: this.$t('right.availableValues.0'), value: 0},
        {text: this.$t('right.availableValues.1'), value: 1},
        {text: this.$t('right.availableValues.2'), value: 2},
      ]
    }
  },
  methods: {
    convertPhotoToDataUrl(){

      let blob = this.user.profile_photo_blob;

      if(blob) {
        let convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
          const reader = new FileReader;
          reader.onerror = reject;
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        });
        convertBlobToBase64(blob).then((result) => {
          this.user.profile_photo_data_url = result;
        });
      } else {
        this.user.profile_photo_data_url = null;
        this.user.is_need_delete_photo = true;
        this.user.profile_photo = null;
      }
    },
    onLoad() {
      if (this.$route.params.id > 0) {
        this.changePassword = false;
        this.$store.dispatch('roles/get')
        this.$store.dispatch('rights/getRights')
        this.$store.dispatch('users/getUserById', {'id': this.$route.params.id}).then(() => {
          if (this.user === null) this.$router.push({name: '404'})
          this.fillRolesAndRights();
        });
      } else {
        this.changePassword = true;
        this.$store.dispatch('roles/get');
        this.$store.dispatch('rights/getRights');
        this.$store.dispatch('users/getNewUser');
        this.fillRolesAndRights();
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      if (this.$route.params.id) {
        this.$store.dispatch('users/update').then((res)=>{
          if( ! res){
            this.$store.dispatch('users/get').then(()=>{
              this.$store.dispatch('users/getUserById', {'id': this.$route.params.id})
            })
          }
        })
      } else {
        this.$store.dispatch('users/create').then((id) => {
          if (id > 0) {
            this.$router.push({name: 'user', params: {id: id}});
          }
        })
      }
    },
    setUserExtraRights() {
      this.user.extra_rights[this.activeShopId] = {};
      for(let i in this.userExtraRights){
        if(this.userExtraRights[i]!==null){
          let tmp = {}
          tmp[i] = this.userExtraRights[i];
          this.user.extra_rights[this.activeShopId][i] = this.userExtraRights[i];
        }
      }
    },
    setUserShop(item) {
      if( ! this.user.shops.includes(item)){
        this.$confirm( {
          title : this._vm.i18n.t('common.confirm'),
          text : this._vm.i18n.t('user.confirm_remove_from_shop', [item.legal_name]),
          cancelText : this._vm.i18n.t('common.no'),
          acceptText : this._vm.i18n.t('common.yes')
        } ).then( async y =>{

        } ).catch( n => {
          this.user.shops.push(item);
        } );
      }


    },
    setUserRoles() {
      this.user.all_roles[this.activeShopId] = [];
      for(let i in this.userRoles){
        if(this.userRoles[i]){
          this.user.all_roles[this.activeShopId].push(this.userRoles[i])
        }
      }
    },
    fillRolesAndRights() {
      if(this.user.all_roles[this.activeShopId]){
        this.user.all_roles[this.activeShopId].forEach((role)=>{
          this.userRoles[role.id+'_'+role.type] = role;
        })
      }
      this.userExtraRights = this.user.extra_rights[this.activeShopId] || {};
    },
    extraRightsColors(value) {
      let color;
      switch (value) {
        case 0:
          color = 'blue-grey';
          break;

        case 1:
          color = 'light-blue accent-2';
          break;

        case 2:
          color = 'green';
          break;
      }
      return color;
    },
    extraRightsSymbol(value) {
      let color;
      switch (value) {
        case 0:
          color = 'fa-ban';
          break;

        case 1:
          color = 'fa-eye';
          break;

        case 2:
          color = 'fa-edit';
          break;
      }
      return color;
    }
  },
}
</script>